import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { TokenService } from '../_services/token.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    constructor( private router: Router,
        private tokenService: TokenService ) { }

    canActivate(activatedRoute: ActivatedRouteSnapshot): boolean | Observable<boolean> | Promise<boolean> {
      if(!this.tokenService.hasToken() || this.tokenService.isTokenExpired()) {
        this.tokenService.logout();

        this.router.navigate(["/login"]);
        return false;
      }
      return true;
    }
  }